import { FC, ReactElement } from 'react';

import { InlineRecentResultsConnected } from '../../components/recentResults/inline/InlineRecentResultsConnected';

import { DesktopBalanceFooter } from './DesktopBalanceFooter';

import styles from './DesktopFooterConnected.module.css';

export const DesktopFooterConnected: FC = (): ReactElement => {
  return (
    <div data-testid="desktop-footer-conected" className={styles.DesktopFooterConnected}>
      <DesktopBalanceFooter />
      <InlineRecentResultsConnected />
    </div>
  );
};
